import React from 'react'
import { Switch, Route as RouteDom, Redirect } from 'react-router-dom'
import { GradientBG, Bio, Breadcrumb, Route, Intro } from '../components'
import { MediaContent } from '../pages'
import artists from './artists'

const Pages = ({ artist, job, pages }) => {
  return pages.map((page) => {
    const jobPath = `${artist.path}${job.path}`
    const pagePath = `${jobPath}${page.path}`

    return (
      <React.Fragment key={page.id}>
        <Route key={pagePath} exact path={pagePath}>
          <MediaContent artist={artist} job={job} page={page} />
          <Breadcrumb artist={artist} job={job} page={page} />
        </Route>
      </React.Fragment>
    )
  })
}

const Jobs = ({ artist }) => {
  return artist.jobs.map((job) => {
    const { path, pages, image, imageHover, title, texts } = job
    const jobPath = `${artist.path}${path}`

    return (
      <React.Fragment key={jobPath}>
        <Route exact path={jobPath}>
          <>
            <Intro
              name={artist.name}
              image={image}
              imageHover={imageHover}
              title={title}
              to={`${jobPath}/info`}
              texts={texts}
            />
            <Breadcrumb
              artist={artist}
              job={job}
              showControllers={false}
              showVolume={false}
              showBio={false}
              backPath="/artists"
            />
          </>
        </Route>
        <Route exact path={`${jobPath}/info`}>
          <Bio
            bios={texts}
            to={`${jobPath}${pages[0].path}`}
            className="g-bio-center"
            playOnClick={artist.name}
          />
          <Breadcrumb
            artist={artist}
            job={job}
            showControllers={false}
            showVolume={false}
            showBio={false}
            backPath={jobPath}
          />
        </Route>
        <Pages artist={artist} job={job} pages={pages} />
      </React.Fragment>
    )
  })
}

const artistsIds = Object.keys(artists)
const artistsFactory = () => {
  return artistsIds.map((id) => {
    const artist = artists[id]
    const artistPath = artist.path
    const bioPath = `${artistPath}/bio`
    const firstJob = artist?.jobs[0]?.path

    return (
      <RouteDom key={id} path={artistPath}>
        <GradientBG />
        <Switch>
          <Route exact path={artistPath}>
            <Redirect to={[artistPath, firstJob].join('')} />
          </Route>
          <Route exact path={bioPath}>
            <Bio bios={artist.bios} />
            <Breadcrumb
              artist={artist}
              showControllers={false}
              showVolume={false}
              showBio={false}
            />
          </Route>
          <Jobs artist={artist}/>
        </Switch>
      </RouteDom>
    )
  })
}

export default artistsFactory
